import { statusMapping } from 'Feature/V2/HbtPortfolioManagement/utils/StatusMapping';
import { TranslationType } from '../types';

export const getStatusLabel = (
  status: keyof ReturnType<typeof statusMapping>,
  t: TranslationType
): string => {
  return statusMapping(t)[status];
};
